import { z } from 'zod';

export const SortDirectionEnum = z.enum(['ascend', 'descend']);

export const PagedRequestSchema = z.object({
  pageNumber: z.number().optional(),
  resultsPerPage: z.number().nonnegative().optional(),
  sortBy: z.string().optional(),
  orderBy: z.string().optional(),
  sortDirection: SortDirectionEnum.optional(),
  sortAscending: z.boolean().optional(),
});

/// @deprecated: please don't use this on UI
export const OldPagedRequestSchema = z.object({
  page: z.number().nonnegative().optional(),
  pageSize: z.number().nonnegative().optional(),
  sortBy: z.string().optional(),
  orderBy: z.string().optional(),
  sortDirection: SortDirectionEnum.optional(),
  sortAscending: z.boolean().optional(),
});

export const PagedResultSchema = z.object({
  pageNumber: z.number().nonnegative(),
  resultsPerPage: z.number().nonnegative().optional(),
  totalResults: z.number().optional(),
  totalPages: z.number().optional(),
  hasMoreResults: z.boolean().optional(),
});

export const SearchRequestSchema = z
  .object({
    searchText: z.coerce.string<string>().optional(),
  })
  .extend(PagedRequestSchema.shape);

// This should be marked as deprecated during zod upgrade as returns optional fields which aren't used in most paginated responses
export const createPaginatedResponseSchema = <ItemSchema extends z.ZodTypeAny>(
  itemSchema: ItemSchema
) => {
  return z
    .object({
      results: z.array(itemSchema),
    })
    .extend(PagedResultSchema.shape);
};

const PaginatedResultSchema = z.object({
  pageNumber: z.number(),
  resultsPerPage: z.number(),
  totalPages: z.number(),
  totalResults: z.number(),
});

export const paginatedResponseSchema = <ItemSchema extends z.ZodTypeAny>({
  results,
}: {
  results: ItemSchema;
}) =>
  PaginatedResultSchema.extend({
    results: z.array(results),
  });

export type SearchRequestModel = z.infer<typeof SearchRequestSchema>;
export type PagedRequestModel = z.infer<typeof PagedRequestSchema>;
